// src/components/ContactUs.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SITE_CONFIG } from '../config';
import { submitChatLead } from '../services/chatLeadService';
import HoneypotField, { withHoneypotValue } from './HoneypotField';
import './ContactUs.css';

const ContactUs = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phoneNumber: '',
    postalCode: '',
    serviceReq: 'buying'
  });
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const params = withHoneypotValue(new URLSearchParams({
        postalCode: formData.postalCode,
        name: formData.name,
        phoneNumber: formData.phoneNumber,
        serviceReq: formData.serviceReq,
        email: formData.email,
        siteId: SITE_CONFIG.SITE_ID
      }), e.currentTarget);

      const response = await submitChatLead(params, { rememberContact: true });

      if (response.ok) {
        setSuccess(true);
        setFormData({ name: '', email: '', phoneNumber: '', postalCode: '', serviceReq: 'buying' });
        setTimeout(() => setSuccess(false), 5000);
      } else {
        alert('Failed to submit. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Failed to submit. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="contact-us-page">
      <button className="back-button" onClick={() => navigate('/')}>
        ← Back to Home
      </button>

      <div className="contact-us-container">
        <div className="contact-us-header">
          <h1>Contact Us</h1>
          <p>Ready to find your dream home or sell your property? Get in touch with {SITE_CONFIG.AGENT.NAME} today!</p>
        </div>

        <div className="contact-us-content">
          <div className="contact-info-section">
            <h2>Get In Touch</h2>
            <div className="contact-detail">
              <span className="contact-icon">📧</span>
              <div>
                <strong>Email</strong>
                <p>{SITE_CONFIG.AGENT.EMAIL}</p>
              </div>
            </div>
            <div className="contact-detail">
              <span className="contact-icon">📞</span>
              <div>
                <strong>Phone</strong>
                <p>{SITE_CONFIG.AGENT.PHONE}</p>
              </div>
            </div>
            <div className="contact-detail">
              <span className="contact-icon">🏠</span>
              <div>
                <strong>Service Area</strong>
                <p>{SITE_CONFIG.STATE}</p>
              </div>
            </div>
          </div>

          <div className="contact-form-section">
            <h2>Send Us a Message</h2>
            {success && (
              <div className="success-message">
                ✓ Thank you! We'll be in touch soon.
              </div>
            )}
            <form onSubmit={handleSubmit}>
              <HoneypotField />
              <input
                type="text"
                placeholder="Full Name *"
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                required
              />
              <input
                type="email"
                placeholder="Email *"
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                required
              />
              <input
                type="tel"
                placeholder="Phone Number *"
                value={formData.phoneNumber}
                onChange={(e) => setFormData({...formData, phoneNumber: e.target.value})}
                required
              />
              <input
                type="text"
                placeholder="ZIP Code *"
                value={formData.postalCode}
                onChange={(e) => setFormData({...formData, postalCode: e.target.value})}
                required
              />
              <select
                value={formData.serviceReq}
                onChange={(e) => setFormData({...formData, serviceReq: e.target.value})}
                required
              >
                <option value="buying">Buying</option>
                <option value="selling">Selling</option>
                <option value="both">Both</option>
              </select>
              <button type="submit" disabled={submitting}>
                {submitting ? 'Submitting...' : 'Submit'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
